module.exports = __webpack_public_path__ + "img/10006.e0c9e9df.png";